gsap.registerPlugin(ScrollTrigger);
gsap.defaults({ ease: "power1.out" });

document.body.classList.add('gsap-init');

let mm = gsap.matchMedia(),
    breakPoint = 768;

mm.add(
    {
        isDesktop: `(min-width: ${breakPoint}px)`,
        isMobile: `(max-width: ${breakPoint - 1}px)`,
        reduceMotion: "(prefers-reduced-motion: reduce)",
    },
    (context) => {

        let { isDesktop, isMobile, reduceMotion } = context.conditions;
        const debuga = false;
        const isEdge = /Edg\//.test(navigator.userAgent);

        const currPageNoAnimation = document.querySelector('.page-template-page-no-title');
        if(currPageNoAnimation) return;
        
        const simpleHeaders = document.querySelectorAll('.ka-simple-animation :is(h1, h2, h3, h4, h5, h6),:is(h1, h2, h3, h4, h5, h6).ka-simple-animation');
        if (simpleHeaders.length > 0 && !reduceMotion) {

            gsap.set(simpleHeaders, { autoAlpha: 0, y: 36 });

            ScrollTrigger.batch(simpleHeaders, {
                start: "top 85%",
                markers: false,
                once: true,
                fastScrollEnd: true,
                onEnter: (batch) =>
                    gsap.to(batch, {
                        autoAlpha: 1,
                        scale: 1,
                        y: 0,
                        visibility: "visible",
                        duration: 0.45,
                        stagger: 0.15,
                        ease: "power1.out",
                    })
            });
        }

        const someHeaders = document.querySelectorAll('.ka-scale-animation');
        if (someHeaders.length > 0 && !reduceMotion) {

            gsap.set(someHeaders, { autoAlpha: 0, y: 50, scaleY: 0 });

            ScrollTrigger.batch(someHeaders, {
                start: "top 85%",
                markers: false,
                once: true,
                fastScrollEnd: true,
                onEnter: (batch) =>
                    gsap.to(batch, {
                        autoAlpha: 1,
                        scale: 1,
                        y: 0,
                        visibility: "visible",
                        duration: 0.45,
                        stagger: 0.15,
                        ease: "power1.out",
                    })
            });
        }

        const simpleItems = document.querySelectorAll('.ka-prop-animation');
        if (simpleItems.length > 0 && !reduceMotion) {

            gsap.set(simpleItems, { autoAlpha: 0, y: 36 });

            ScrollTrigger.batch(simpleItems, {
                start: "top 85%",
                markers: false,
                onEnter: (batch) =>
                    gsap.to(batch, {
                        autoAlpha: 1,
                        y: 0,
                        visibility: "visible",
                        duration: 0.7,
                        stagger: 0.15,
                        ease: "power1.out",
                    })
            });
        }

        const fadeItems = document.querySelectorAll('.ka-fade-animation');
        if (fadeItems.length > 0 && !reduceMotion) {

            gsap.set(fadeItems, { autoAlpha: 0 });

            ScrollTrigger.batch(fadeItems, {
                start: "top 85%",
                markers: false,
                onEnter: (batch) =>
                    gsap.to(batch, {
                        autoAlpha: 1,
                        visibility: "visible",
                        duration: 0.7,
                        stagger: 0.15,
                        ease: "power1.out",
                    })
            });
        }

        const pageBlocks = document.querySelectorAll('.wp-block-post');
        if (pageBlocks.length > 0 && !reduceMotion) {

            gsap.set(pageBlocks, { autoAlpha: 0, y: 75 });

            ScrollTrigger.batch(pageBlocks, {
                start: "top 85%",
                markers: false,
                once: true,
                fastScrollEnd: true,
                onEnter: (batch) =>
                    gsap.to(batch, {
                        autoAlpha: 1,
                        y: 0,
                        visibility: "visible",
                        duration: 0.7,
                        stagger: 0.15,
                        ease: "power1.out",
                    })
            });
        }


        const pricesBlocks = document.querySelectorAll('.car-main-buttons');
        if (pricesBlocks.length > 0 && !reduceMotion) {

            pricesBlocks.forEach((pricesBlock) => {
                const callBtn = pricesBlock.querySelector(".callus-button");
                const whatsappBtn = pricesBlock.querySelector(".whatsapp-button");

                if (callBtn) gsap.set(callBtn, { autoAlpha: 0, y: 50 });
                if (whatsappBtn) gsap.set(whatsappBtn, { autoAlpha: 0, y: 50 });

                if (callBtn || whatsappBtn) {
                    const tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: pricesBlock,
                            start: "top 80%",
                            toggleActions: "play none none none",
                            markers: false
                        }
                    });

                    if (callBtn) {
                        tl.to(callBtn, {
                            y: 0,
                            opacity: 1,
                            visibility: "visible",
                            duration: 0.35,
                            ease: "power1.out"
                        });
                    }
                    if (whatsappBtn) {
                        tl.to(whatsappBtn, {
                            y: 0,
                            opacity: 1,
                            visibility: "visible",
                            duration: 0.35,
                            ease: "power1.out"
                        });
                    }
                }
            });

        }

        //Stick headers

        const mobileMenu = document.querySelector('header');
        if (mobileMenu) {
            // Only for mobile
            //if (window.innerWidth < 768) {
                ScrollTrigger.create({
                    trigger: 'html',
                    start: "top top",
                    onEnter: () => {
                        mobileMenu.classList.add("is-sticky");
                        mobileMenu.classList.remove("is-top");
                    },
                    onLeaveBack: () => {
                        mobileMenu.classList.add("is-top");
                    },
                    onUpdate: self => {
                        if (self.direction === -1) {
                            mobileMenu.classList.add("scrolling-up");
                            mobileMenu.classList.remove("scrolling-down");
                        } else {
                            mobileMenu.classList.remove("scrolling-up");
                            mobileMenu.classList.add("scrolling-down");
                        }
                    }
                });
            //}
        }

        const mainPageEls = document.querySelectorAll(".top-header-animation");
        if (mainPageEls.length > 0 && !reduceMotion) {

            gsap.set(mainPageEls, { autoAlpha: 0, scale: 0.5, y: 100 });

            gsap.to(mainPageEls, {
                autoAlpha: 1,
                opacity: 1,
                scale: 1,
                y: 0,
                duration: 2.4,
                stagger: 0.25,
                ease: "power2.out",
                toggleActions: "restart none none none",
                once: true
            });
        };

        const topHeaderPageEls = document.querySelectorAll("h1.wp-block-heading,h2.wp-block-heading,h1.wp-block-post-title,h2.wp-block-post-title,.swt-block-page-banner-group-left,.swt-block-page-banner-group");
        if (topHeaderPageEls.length > 0 && !reduceMotion) {

            gsap.set(topHeaderPageEls, { autoAlpha: 0, x: -20});

            gsap.to(topHeaderPageEls, {
                "--before-opacity": 1,
                autoAlpha: 1,
                scale: 1,
                x: 0,
                duration: 1.4,
                stagger: 0.35,
                ease: "power2.out"
            });
        };

        window.addEventListener("resize", () => {
            ScrollTrigger.refresh();
        });

    });

document.addEventListener("DOMContentLoaded", function () {

    var openBtn = document.querySelector('.wp-block-navigation__responsive-container-open');
    var closeBtn = document.querySelector('.wp-block-navigation__responsive-container-close');
    var menu = document.querySelector('.wp-block-navigation__responsive-container');

    if (!openBtn || !menu) return;
    if (typeof menu.dataset.wpClassHasModalOpen !== "undefined") return;

    function openMenu() {
        menu.classList.add("is-menu-open");
        menu.classList.add("has-modal-open");
    }
    function closeMenu() {
        menu.classList.remove("is-menu-open");
        menu.classList.remove("has-modal-open");
    }

    openBtn.addEventListener("click", openMenu);
    if (closeBtn) closeBtn.addEventListener("click", closeMenu);

});
/*
document.addEventListener("DOMContentLoaded", () => {const videos = document.querySelectorAll('.ka-video-reverse video');

  if (!videos.length) return;

  videos.forEach((video) => {
    video.pause();
    let direction = 1;
    let lastTime = performance.now();

    function animate() {
      const now = performance.now();
      const delta = (now - lastTime) / 1000;
      lastTime = now;


      video.currentTime += direction * delta;


      if (video.currentTime >= video.duration) {
        direction = -1;
        video.currentTime = video.duration; 
      } else if (video.currentTime <= 0) {
        direction = 1;
        video.currentTime = 0;
      }

      requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);
  });
});
*/